import { FC, useEffect, useMemo, useState } from 'react';
import { BubbleTabController } from '../BubbleTabController';
import { TournamentScorecardPageStandingsSwitcher } from '../TournamentScorecardPageStandingsSwitcher';

import { IStandingRound , IStandingGroup } from '../../TournamentScorecardPage.types';

import { ClassFormatEnum, GroupStandingsTieBreakerEnum } from '../../../../types/enums';
import { sortGroupStandingsRows } from '../../../../utils/groupStandingsRanking';

import './StandingsTournametList.scss';

interface StandingsTournametListProps {
    matches: (IStandingRound | IStandingGroup)[];
    format: ClassFormatEnum;
    groupStandingsTieBreakers?: GroupStandingsTieBreakerEnum[];
}

const isGroupStanding = (
    standing: IStandingRound | IStandingGroup | null,
): standing is IStandingGroup => Boolean(standing && 'teams' in standing);

export const StandingsTournametList: FC<StandingsTournametListProps> = ({
    matches = [],
    format,
    groupStandingsTieBreakers,
}) => {
  const [selectedStanding, setSelectedStanding] = useState<IStandingRound | IStandingGroup | null>(
    matches[0] ?? null,
  );

  useEffect(() => {
    setSelectedStanding(matches[0] ?? null);
  }, [matches]);

  const activeStanding = selectedStanding ?? matches[0] ?? null;
  const renderedStanding = useMemo<IStandingRound | IStandingGroup | null>(() => {
    if (!isGroupStanding(activeStanding)) {
      return activeStanding;
    }

    return {
      ...activeStanding,
      teams: sortGroupStandingsRows(
        activeStanding.teams,
        groupStandingsTieBreakers,
      ),
    };
  }, [activeStanding, groupStandingsTieBreakers]);
  
  return (<div className="standings-tournamet-list">
        <div className="standings-tournamet-list__select-holder">
            <BubbleTabController selected={activeStanding} data={matches} keyToShow="name" callback={setSelectedStanding}/>
        </div>
        
        <div className="standings-tournamet-list__info-card">
            {renderedStanding && (
              <TournamentScorecardPageStandingsSwitcher format={format} {...renderedStanding}/>
            )}
        </div>   
    </div>)
};